import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function login (data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getInfo () {
  const token = getToken()
  if(!token) {
    return true
  }
  const ret = request({
    url: '/auth/check',
    method: 'get'
  })
  ret.catch(() => console.error('User not logged'))
  return ret
}

export function logout () {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

export function resetPass (data) {
  return request({
    url: '/auth/resetPassword',
    method: 'post',
    data
  })
}

export function confirmResetPass (data) {
  return request({
    url: '/auth/confirmResetPassword',
    method: 'post',
    data
  })
}

export function checkTokenLinkPass (data) {
  return request({
    url: '/auth/checkTokenLinkPass',
    method: 'post',
    data
  })
}

export function changePass (data) {
  return request({
    url: '/auth/changePassword',
    method: 'post',
    data
  })
}

export function getConfig() {
  const ret = request({
    url: '/config',
    method: 'get'
  })
  return ret  
}